import { QuestionParam } from './questionData';

export interface CreateAndModifySurvey {
  anonymousReadOnly: boolean;
  anonymousResponse: boolean;
  assignedResponse: boolean;
  deleted: boolean;
  description: string;
  distributed: boolean;
  distributedAt: string;
  endedAt: string;
  multipleResponse: boolean;
  responseModifiable: boolean;
  responseTestUrl: string;
  responseUrl: string;
  resultUrl: string;
  startedAt: string;
  surveyId: string;
  surveyTitle: string;
  endDescription: string;
  endTitle: string;
}

export interface Survey extends CommonValue {
  surveyId: string;
  surveyTitle: string;
  description: string;
  responseTestUrl: string;
  responseUrl: string;
  resultUrl: string;
  anonymousResponse: boolean;
  multipleResponse: boolean;
  responseModifiable: boolean;
  distributed: boolean;
  distributedAt: string;
  startedAt: string;
  endedAt: string;
  deleted: boolean;
  questions: QuestionParam[];
  surveyParticipants: Target[];
  responses: Response[];
  endDescription: string;
  endTitle: string;
  responded: boolean;
  hidden: boolean;
  anonymousReadOnly: boolean;
  fileGroup: FileGroup;
}

export interface SurveyResult {
  anonymousReadOnly: boolean;
  anonymousResponse: boolean;
  assignedResponse: boolean;
  multipleResponse: boolean;
  distributed: boolean;
  endedAt: string;
  noResponseCnt: number;
  noResponseParticipants: any[];
  responseCnt: number;
  responseParticipants: any[];
  responseRate: number;
  responseResults: ResponseResult[];
  startedAt: string;
  surveyId: string;
  surveyTitle: string;
  totalCnt: number;
  createdBy: string;
}

export interface ResponseResult {
  question: Question;
  responses: any[];
}

export interface Response extends CommonValue {
  responseId: string | null;
  surveyParticipantId: string | null;
  userId: string;
  questionId: string | null;
  responseText: string | null;
  responseValue: number | null;
  responseOption: ResponseOption;

  optionId: string | null;
  optionEtcText?: string;
}

export interface ResponseOption {
  optionResponseId: string;
  optionEtcText: string;
  questionOption: QuestionOption;
}

export interface Question extends CommonValue {
  questionId: string;
  questionNo: number;
  questionOrder: string;
  questionName: string;
  questionType: string;
  deleted: boolean;
  required: boolean;
  multipleOptionSelected: boolean;
  etcOptionUsed: boolean;
  linearScaleLevel: number | null;
  linearScaleLabel1: string | null;
  linearScaleLabel2: string | null;
  sectionTitle: string | null;
  sectionDescription: string | null;
  questionOptions: QuestionOption[];
}

export interface FileGroup {
  fileGroupId: string;
  fileList: File[];
}

export interface File {
  fileId: string;
  fileName: string;
  fileOriginExt: string;
  fileOriginName: string;
  represented: boolean;
}

export class QuestionOption {
  optionId: string | null = null;
  optionNo: string | null = null;
  optionText: string | null = null;
  optionOrder: number = 0;
  optionResponseId: string | null = null;

  constructor(any?: any) {
    this.optionId = any?.optionId || null;
    this.optionNo = any?.optionNo || null;
    this.optionText = any?.optionText || null;
    this.optionOrder = any?.optionOrder || 0;
  }
}

export interface SurveyParticipant {
  surveyParticipantId: string;
  userId: string;
  surveyId: string;
  deleted: boolean;
}

export interface CommonValue {
  createdAt: string;
  createdBy: string;
  modifiedAt: string;
  modifiedBy: string;
}

export interface SendingResponseData {
  responseId: string;
  responses: SendingResponse[];
}

export class SendingResponse {
  public optionId: string | null = null;
  public questionId: string = '';
  public questionType: any = null;
  public responseText: string | null = null;
  public responseValue: number | null = null;
  public optionEtcText: string | null = null;
  public optionResponseId: string | null = null;
}

export class DistributeParam {
  public assignedResponse: boolean | null = null;
  public distributed: boolean | null = null;
  public endedAt: string | null = null;
  public startedAt: string | null = null;
  public surveyParticipants: Target[] | null = null;
  public hidden: boolean | null = null;
  public anonymousReadOnly: boolean | null = null;
}

export class Target {
  public readOnly: boolean = false;
  public surveyParticipantId: string | null = null;
  public userId: any = null;

  constructor(any?: any) {
    this.readOnly = any?.readOnly || false;
    this.surveyParticipantId = any?.surveyParticipantId || null;
    this.userId = any?.userId || null;
  }
}

export class UpdateViewerParam {
  public addIds: string[] | null = null;
  public removeIds: string[] | null = null;
  public anonymousReadOnly: boolean | null = null;
}
